export enum ConfigurationKey {
  ALLEGRO_CLIENT_KEY = 'allegroClientKey',
  ALLEGRO_CLIENT_SECRET = 'allegroClientSecret',
  ALLEGRO_API_URL = 'allegroApiUrl',
  ALLEGRO_SANDBOX_CLIENT_KEY = 'allegroSandboxClientKey',
  ALLEGRO_SANDBOX_CLIENT_SECRET = 'allegroSandboxClientSecret',
  ALLEGRO_SANDBOX_API_URL = 'allegroSandboxApiUrl',
  ALLEGRO_SANDBOX_ENABLED = 'allegroSandboxEnabled',
  ALLEGRO_AUTH_URL = 'allegroAuthUrl',
  ALLEGRO_SANDBOX_AUTH_URL = 'allegroSandboxAuthUrl',
  ALLEGRO_REDIRECT_URI = 'allegroRedirectUri',
  ALLEGRO_SANDBOX_REDIRECT_URI = 'allegroSandboxRedirectUri',
  ALLEGRO_SANDBOX_REFRESH_TOKEN = 'allegroSandboxRefreshToken',
  ALLEGRO_REFRESH_TOKEN = 'allegroRefreshToken',
  INTERCARS_USER_PATH = 'intercarsUserPath',
  INTERCARS_LOGIN = 'intercarsLogin',
  INTERCARS_PASS = 'intercarsPass',
  INTERCARS_CLIENT_ID = 'intercarsClientId',
  INTERCARS_CLIENT_SECRET = 'intercarsClientSecret',
  INTERCARS_AUTH_URL = 'intercarsAuthUrl',
  INTERCARS_API_URL = 'intercarsApiUrl',
  INTERCARS_HOST = 'intercarsHost',
  INTERCARS_SANDBOX_USER_PATH = 'intercarsSandboxUserPath',
  INTERCARS_SANDBOX_LOGIN = 'intercarsSandboxLogin',
  INTERCARS_SANDBOX_PASS = 'intercarsSandboxPass',
  INTERCARS_SANDBOX_HOST = 'intercarsSandboxHost',
  PRODUCT_INFORMATION_RELOAD_CRON = 'productInformationReloadCron',
  PRODUCT_IMAGE_RELOAD_CRON = 'productImageReloadCron',
  PRODUCT_IMAGE_SYNC_ENABLED = 'productImageSyncEnabled',
  STOCK_RELOAD_CRON = 'stockReloadCron',
  ADDITIONAL_DESCRIPTION = 'additionalDescription',
  ADDITIONAL_DESCRIPTION_ENABLED = 'additionalDescriptionEnabled',
  ALWAYS_RELOAD_AUCTIONS_AFTER_SAVE = 'alwaysReloadAuctionsAfterSave',
  ALWAYS_RELOAD_INPOST_AFTER_SAVE = 'alwaysReloadInpostAfterSave',
  WAREHOUSE_ENABLED_LIST = 'warehouseEnabledList',
  PRICE_API_UPDATE_CRON = 'priceApiUpdateCron',
  PRICE_API_SYNC_ENABLED = 'priceApiSyncEnabled',
  USE_ONLY_PRODUCTS_WITH_IMAGES = 'useOnlyProductsWithImages',
  USE_ONLY_PRODUCTS_WITH_DIMENSIONS = 'useOnlyProductsWithDimensions',
  MINIMUM_STOCK = 'minimumStock',
  AUCTIONS_RELOAD_CRON = 'auctionsReloadCron',
  GROSS_PERCENT = 'grossPercent',
  BATCH_SIZE = 'batchSize',
  CREATE_AUCTIONS_AS_ACTIVE = 'createAuctionsAsActive',
  STOCK_INVENTORY_UPDATE_CRON = 'stockInventoryUpdateCron',
  PRODUCT_DESCRIPTION_UPDATE_CRON = 'productDescriptionUpdateCron',
  BLACKLISTED_PRODUCTS = 'blacklistedProducts',
  SHOULD_UPDATE_PRICE = 'shouldUpdatePrice',
  EXCLUDED_MANUFACTURERS = 'excludedManufacturers',
  MAXIMUM_AUCTION_PRICE = 'maximumAuctionPrice',
  MIN_PRICE_ADJUSTMENT_ENABLED = 'minPriceAdjustmentEnabled',
  MIN_PRICE_ADJUSTMENT_THRESHOLD = 'minPriceAdjustmentThreshold',
  MIN_PRICE_ADJUSTMENT_VALUE = 'minPriceAdjustmentValue',
  DELIVERIES = 'deliveries',
  MIN_DELIVERY_TIME = 'minDeliveryTime',
  GROSS_PERCENT_RANGES = 'grossPercentRanges',

  // InPost Marketplace
  INPOST_CLIENT_ID = 'inpostClientId',
  INPOST_CLIENT_SECRET = 'inpostClientSecret',
  INPOST_API_URL = 'inpostApiUrl',
  INPOST_AUTH_URL = 'inpostAuthUrl',
  INPOST_ORGANIZATION_ID = 'inpostOrganizationId',
  INPOST_SANDBOX_ENABLED = 'inpostSandboxEnabled',
  INPOST_SANDBOX_CLIENT_ID = 'inpostSandboxClientId',
  INPOST_SANDBOX_CLIENT_SECRET = 'inpostSandboxClientSecret',
  INPOST_SANDBOX_API_URL = 'inpostSandboxApiUrl',
  INPOST_SANDBOX_AUTH_URL = 'inpostSandboxAuthUrl',
  INPOST_SANDBOX_ORGANIZATION_ID = 'inpostSandboxOrganizationId',
  INPOST_OFFERS_RELOAD_CRON = 'inpostOffersReloadCron',
  INPOST_CREATE_OFFERS_AS_ACTIVE = 'inpostCreateOffersAsActive',
  INPOST_GROSS_PERCENT = 'inpostGrossPercent',
  INPOST_GROSS_PERCENT_RANGES = 'inpostGrossPercentRanges',
  INPOST_BATCH_SIZE = 'inpostBatchSize',
  INPOST_MINIMUM_STOCK = 'inpostMinimumStock',
  INPOST_MAXIMUM_OFFER_PRICE = 'inpostMaximumOfferPrice',
  INPOST_BLACKLISTED_PRODUCTS = 'inpostBlacklistedProducts',
  INPOST_EXCLUDED_MANUFACTURERS = 'inpostExcludedManufacturers',
  INPOST_SYNC_ENABLED = 'inpostSyncEnabled',
  INPOST_WHITELISTED_PRODUCTS = 'inpostWhitelistedProducts',
  INPOST_DEFAULT_CATEGORY_ID = 'inpostDefaultCategoryId',
  INPOST_CATEGORIES_RELOAD_CRON = 'inpostCategoriesReloadCron',
  INPOST_ADDITIONAL_DESCRIPTION = 'inpostAdditionalDescription',
  INPOST_HINT_API_ENABLED = 'inpostHintApiEnabled',
  INPOST_REASSIGN_CATEGORIES = 'inpostReassignCategories',
  INPOST_REASSIGN_CATEGORIES_CRON = 'inpostReassignCategoriesCron',

  // Performance
  ALLEGRO_CONCURRENCY = 'allegroConcurrency',
  INPOST_CONCURRENCY = 'inpostConcurrency',

  // Errored auction retry
  ERRORED_AUCTION_RETRY_DAYS = 'erroredAuctionRetryDays',
}

export enum ConfigurationType {
  APP,
  DETAIL,
}

export enum ConfigurationValueType {
  NUMBER,
  STRING,
  BOOLEAN,
  STRING_LIST,
  TEXTAREA,
  STRING_CRON,
  GROSS_PERCENT_RANGES,
  COMBO_BOX,
  CATEGORY_TREE
}

export interface GrossPercentRange {
  min: number;
  max: number;
  grossPercent: number;
}

export type ConfigurationCategory = 'Allegro' | 'InterCars' | 'InPost' | 'General';

export const configurations: Map<
  ConfigurationKey,
  {
    keyType: ConfigurationType;
    valueType: ConfigurationValueType;
    restricted: boolean;
    comboBoxOptions?: string[];
    category: ConfigurationCategory;
  }
> = new Map<
  ConfigurationKey,
  { keyType: ConfigurationType; valueType: ConfigurationValueType; restricted: boolean; comboBoxOptions?: string[]; category: ConfigurationCategory }
>([
  // ===== Allegro =====
  [
    ConfigurationKey.MAXIMUM_AUCTION_PRICE,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.NUMBER, restricted: true, category: 'Allegro' },
  ],
  [
    ConfigurationKey.MIN_PRICE_ADJUSTMENT_ENABLED,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.BOOLEAN, restricted: false, category: 'Allegro' },
  ],
  [
    ConfigurationKey.MIN_PRICE_ADJUSTMENT_THRESHOLD,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.NUMBER, restricted: false, category: 'Allegro' },
  ],
  [
    ConfigurationKey.MIN_PRICE_ADJUSTMENT_VALUE,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.NUMBER, restricted: false, category: 'Allegro' },
  ],
  [
    ConfigurationKey.DELIVERIES,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING_LIST, restricted: true, category: 'Allegro' },
  ],
  [
    ConfigurationKey.MIN_DELIVERY_TIME,
    {
      keyType: ConfigurationType.APP, valueType: ConfigurationValueType.COMBO_BOX, restricted: false, category: 'Allegro',
      comboBoxOptions: ['PT24H', 'P2D', 'P3D', 'P4D', 'P5D', 'P7D', 'P10D', 'P14D', 'P21D', 'P30D', 'P60D'],
    },
  ],
  [
    ConfigurationKey.ALLEGRO_CLIENT_KEY,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING, restricted: true, category: 'Allegro' },
  ],
  [
    ConfigurationKey.ALLEGRO_CLIENT_SECRET,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING, restricted: true, category: 'Allegro' },
  ],
  [
    ConfigurationKey.ALLEGRO_API_URL,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING, restricted: true, category: 'Allegro' },
  ],
  [
    ConfigurationKey.ALLEGRO_AUTH_URL,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING, restricted: true, category: 'Allegro' },
  ],
  [
    ConfigurationKey.ALLEGRO_SANDBOX_CLIENT_KEY,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING, restricted: true, category: 'Allegro' },
  ],
  [
    ConfigurationKey.ALLEGRO_SANDBOX_CLIENT_SECRET,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING, restricted: true, category: 'Allegro' },
  ],
  [
    ConfigurationKey.ALLEGRO_SANDBOX_API_URL,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING, restricted: true, category: 'Allegro' },
  ],
  [
    ConfigurationKey.ALLEGRO_SANDBOX_AUTH_URL,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING, restricted: true, category: 'Allegro' },
  ],
  [
    ConfigurationKey.ALLEGRO_SANDBOX_ENABLED,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.BOOLEAN, restricted: true, category: 'Allegro' },
  ],
  [
    ConfigurationKey.ALLEGRO_REDIRECT_URI,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING, restricted: true, category: 'Allegro' },
  ],
  [
    ConfigurationKey.ALLEGRO_SANDBOX_REDIRECT_URI,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING, restricted: true, category: 'Allegro' },
  ],
  [
    ConfigurationKey.ALLEGRO_REFRESH_TOKEN,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING, restricted: true, category: 'Allegro' },
  ],
  [
    ConfigurationKey.ALLEGRO_SANDBOX_REFRESH_TOKEN,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING, restricted: true, category: 'Allegro' },
  ],
  [
    ConfigurationKey.GROSS_PERCENT_RANGES,
    { keyType: ConfigurationType.DETAIL, valueType: ConfigurationValueType.TEXTAREA, restricted: true, category: 'Allegro' },
  ],
  [
    ConfigurationKey.AUCTIONS_RELOAD_CRON,
    { keyType: ConfigurationType.DETAIL, valueType: ConfigurationValueType.STRING_CRON, restricted: true, category: 'Allegro' },
  ],
  [
    ConfigurationKey.GROSS_PERCENT,
    { keyType: ConfigurationType.DETAIL, valueType: ConfigurationValueType.NUMBER, restricted: false, category: 'Allegro' },
  ],
  [
    ConfigurationKey.BATCH_SIZE,
    { keyType: ConfigurationType.DETAIL, valueType: ConfigurationValueType.NUMBER, restricted: true, category: 'Allegro' },
  ],
  [
    ConfigurationKey.ALLEGRO_CONCURRENCY,
    { keyType: ConfigurationType.DETAIL, valueType: ConfigurationValueType.NUMBER, restricted: true, category: 'Allegro' },
  ],
  [
    ConfigurationKey.CREATE_AUCTIONS_AS_ACTIVE,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.BOOLEAN, restricted: false, category: 'Allegro' },
  ],
  [
    ConfigurationKey.PRODUCT_DESCRIPTION_UPDATE_CRON,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING_CRON, restricted: true, category: 'Allegro' },
  ],
  [
    ConfigurationKey.BLACKLISTED_PRODUCTS,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.TEXTAREA, restricted: false, category: 'Allegro' },
  ],
  [
    ConfigurationKey.SHOULD_UPDATE_PRICE,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.BOOLEAN, restricted: false, category: 'Allegro' },
  ],
  [
    ConfigurationKey.EXCLUDED_MANUFACTURERS,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.TEXTAREA, restricted: false, category: 'Allegro' },
  ],
  [
    ConfigurationKey.ERRORED_AUCTION_RETRY_DAYS,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.NUMBER, restricted: false, category: 'Allegro' },
  ],

  // ===== InterCars =====
  [
    ConfigurationKey.INTERCARS_USER_PATH,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING, restricted: true, category: 'InterCars' },
  ],
  [
    ConfigurationKey.INTERCARS_LOGIN,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING, restricted: true, category: 'InterCars' },
  ],
  [
    ConfigurationKey.INTERCARS_PASS,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING, restricted: true, category: 'InterCars' },
  ],
  [
    ConfigurationKey.INTERCARS_HOST,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING, restricted: true, category: 'InterCars' },
  ],
  [
    ConfigurationKey.INTERCARS_CLIENT_ID,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING, restricted: true, category: 'InterCars' },
  ],
  [
    ConfigurationKey.INTERCARS_CLIENT_SECRET,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING, restricted: true, category: 'InterCars' },
  ],
  [
    ConfigurationKey.INTERCARS_AUTH_URL,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING, restricted: true, category: 'InterCars' },
  ],
  [
    ConfigurationKey.INTERCARS_API_URL,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING, restricted: true, category: 'InterCars' },
  ],
  [
    ConfigurationKey.INTERCARS_SANDBOX_USER_PATH,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING, restricted: true, category: 'InterCars' },
  ],
  [
    ConfigurationKey.INTERCARS_SANDBOX_LOGIN,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING, restricted: true, category: 'InterCars' },
  ],
  [
    ConfigurationKey.INTERCARS_SANDBOX_PASS,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING, restricted: true, category: 'InterCars' },
  ],
  [
    ConfigurationKey.INTERCARS_SANDBOX_HOST,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING, restricted: true, category: 'InterCars' },
  ],
  [
    ConfigurationKey.PRODUCT_INFORMATION_RELOAD_CRON,
    { keyType: ConfigurationType.DETAIL, valueType: ConfigurationValueType.STRING_CRON, restricted: true, category: 'InterCars' },
  ],
  [
    ConfigurationKey.PRODUCT_IMAGE_RELOAD_CRON,
    { keyType: ConfigurationType.DETAIL, valueType: ConfigurationValueType.STRING_CRON, restricted: true, category: 'InterCars' },
  ],
  [
    ConfigurationKey.PRODUCT_IMAGE_SYNC_ENABLED,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.BOOLEAN, restricted: false, category: 'InterCars' },
  ],
  [
    ConfigurationKey.STOCK_INVENTORY_UPDATE_CRON,
    { keyType: ConfigurationType.DETAIL, valueType: ConfigurationValueType.STRING_CRON, restricted: true, category: 'InterCars' },
  ],
  [
    ConfigurationKey.STOCK_RELOAD_CRON,
    { keyType: ConfigurationType.DETAIL, valueType: ConfigurationValueType.STRING_CRON, restricted: true, category: 'InterCars' },
  ],
  [
    ConfigurationKey.WAREHOUSE_ENABLED_LIST,
    { keyType: ConfigurationType.DETAIL, valueType: ConfigurationValueType.STRING, restricted: true, category: 'InterCars' },
  ],
  [
    ConfigurationKey.PRICE_API_UPDATE_CRON,
    { keyType: ConfigurationType.DETAIL, valueType: ConfigurationValueType.STRING_CRON, restricted: true, category: 'InterCars' },
  ],
  [
    ConfigurationKey.PRICE_API_SYNC_ENABLED,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.BOOLEAN, restricted: false, category: 'InterCars' },
  ],

  // ===== General =====
  [
    ConfigurationKey.ADDITIONAL_DESCRIPTION,
    { keyType: ConfigurationType.DETAIL, valueType: ConfigurationValueType.TEXTAREA, restricted: false, category: 'General' },
  ],
  [
    ConfigurationKey.ADDITIONAL_DESCRIPTION_ENABLED,
    { keyType: ConfigurationType.DETAIL, valueType: ConfigurationValueType.BOOLEAN, restricted: false, category: 'General' },
  ],
  [
    ConfigurationKey.ALWAYS_RELOAD_AUCTIONS_AFTER_SAVE,
    { keyType: ConfigurationType.DETAIL, valueType: ConfigurationValueType.BOOLEAN, restricted: false, category: 'Allegro' },
  ],
  [
    ConfigurationKey.ALWAYS_RELOAD_INPOST_AFTER_SAVE,
    { keyType: ConfigurationType.DETAIL, valueType: ConfigurationValueType.BOOLEAN, restricted: false, category: 'InPost' },
  ],
  [
    ConfigurationKey.USE_ONLY_PRODUCTS_WITH_IMAGES,
    { keyType: ConfigurationType.DETAIL, valueType: ConfigurationValueType.BOOLEAN, restricted: false, category: 'General' },
  ],
  [
    ConfigurationKey.USE_ONLY_PRODUCTS_WITH_DIMENSIONS,
    { keyType: ConfigurationType.DETAIL, valueType: ConfigurationValueType.BOOLEAN, restricted: true, category: 'General' },
  ],
  [
    ConfigurationKey.MINIMUM_STOCK,
    { keyType: ConfigurationType.DETAIL, valueType: ConfigurationValueType.NUMBER, restricted: true, category: 'General' },
  ],

  // ===== InPost Marketplace =====
  [
    ConfigurationKey.INPOST_CLIENT_ID,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING, restricted: true, category: 'InPost' },
  ],
  [
    ConfigurationKey.INPOST_CLIENT_SECRET,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING, restricted: true, category: 'InPost' },
  ],
  [
    ConfigurationKey.INPOST_API_URL,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING, restricted: true, category: 'InPost' },
  ],
  [
    ConfigurationKey.INPOST_AUTH_URL,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING, restricted: true, category: 'InPost' },
  ],
  [
    ConfigurationKey.INPOST_ORGANIZATION_ID,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING, restricted: true, category: 'InPost' },
  ],
  [
    ConfigurationKey.INPOST_SANDBOX_ENABLED,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.BOOLEAN, restricted: true, category: 'InPost' },
  ],
  [
    ConfigurationKey.INPOST_SANDBOX_CLIENT_ID,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING, restricted: true, category: 'InPost' },
  ],
  [
    ConfigurationKey.INPOST_SANDBOX_CLIENT_SECRET,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING, restricted: true, category: 'InPost' },
  ],
  [
    ConfigurationKey.INPOST_SANDBOX_API_URL,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING, restricted: true, category: 'InPost' },
  ],
  [
    ConfigurationKey.INPOST_SANDBOX_AUTH_URL,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING, restricted: true, category: 'InPost' },
  ],
  [
    ConfigurationKey.INPOST_SANDBOX_ORGANIZATION_ID,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING, restricted: true, category: 'InPost' },
  ],
  [
    ConfigurationKey.INPOST_OFFERS_RELOAD_CRON,
    { keyType: ConfigurationType.DETAIL, valueType: ConfigurationValueType.STRING_CRON, restricted: true, category: 'InPost' },
  ],
  [
    ConfigurationKey.INPOST_CREATE_OFFERS_AS_ACTIVE,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.BOOLEAN, restricted: false, category: 'InPost' },
  ],
  [
    ConfigurationKey.INPOST_GROSS_PERCENT,
    { keyType: ConfigurationType.DETAIL, valueType: ConfigurationValueType.NUMBER, restricted: false, category: 'InPost' },
  ],
  [
    ConfigurationKey.INPOST_GROSS_PERCENT_RANGES,
    { keyType: ConfigurationType.DETAIL, valueType: ConfigurationValueType.TEXTAREA, restricted: true, category: 'InPost' },
  ],
  [
    ConfigurationKey.INPOST_BATCH_SIZE,
    { keyType: ConfigurationType.DETAIL, valueType: ConfigurationValueType.NUMBER, restricted: true, category: 'InPost' },
  ],
  [
    ConfigurationKey.INPOST_CONCURRENCY,
    { keyType: ConfigurationType.DETAIL, valueType: ConfigurationValueType.NUMBER, restricted: true, category: 'InPost' },
  ],
  [
    ConfigurationKey.INPOST_MINIMUM_STOCK,
    { keyType: ConfigurationType.DETAIL, valueType: ConfigurationValueType.NUMBER, restricted: true, category: 'InPost' },
  ],
  [
    ConfigurationKey.INPOST_MAXIMUM_OFFER_PRICE,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.NUMBER, restricted: true, category: 'InPost' },
  ],
  [
    ConfigurationKey.INPOST_BLACKLISTED_PRODUCTS,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.TEXTAREA, restricted: false, category: 'InPost' },
  ],
  [
    ConfigurationKey.INPOST_EXCLUDED_MANUFACTURERS,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.TEXTAREA, restricted: false, category: 'InPost' },
  ],
  [
    ConfigurationKey.INPOST_SYNC_ENABLED,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.BOOLEAN, restricted: false, category: 'InPost' },
  ],
  [
    ConfigurationKey.INPOST_WHITELISTED_PRODUCTS,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.TEXTAREA, restricted: false, category: 'InPost' },
  ],
  [
    ConfigurationKey.INPOST_DEFAULT_CATEGORY_ID,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.CATEGORY_TREE, restricted: false, category: 'InPost' },
  ],
  [
    ConfigurationKey.INPOST_CATEGORIES_RELOAD_CRON,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING, restricted: false, category: 'InPost' },
  ],
  [
    ConfigurationKey.INPOST_ADDITIONAL_DESCRIPTION,
    { keyType: ConfigurationType.DETAIL, valueType: ConfigurationValueType.TEXTAREA, restricted: false, category: 'InPost' },
  ],
  [
    ConfigurationKey.INPOST_HINT_API_ENABLED,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.BOOLEAN, restricted: false, category: 'InPost' },
  ],
  [
    ConfigurationKey.INPOST_REASSIGN_CATEGORIES,
    { keyType: ConfigurationType.DETAIL, valueType: ConfigurationValueType.BOOLEAN, restricted: false, category: 'InPost' },
  ],
  [
    ConfigurationKey.INPOST_REASSIGN_CATEGORIES_CRON,
    { keyType: ConfigurationType.APP, valueType: ConfigurationValueType.STRING_CRON, restricted: false, category: 'InPost' },
  ],
]);
